import styled, { css } from 'styled-components'

import Link from '../../Link'
import LoginLink from '../../LoginLink'
import LogoutLink from '../../LogoutLink'
import RegistrationLink from '../../RegistrationLink'
import { MenuAccordion } from '../MenuAccordion'
import { MenuAccordionCollapse } from '../MenuAccordionCollapse'
import MobileCartIconImport from '../MobileCartIcon'
import { mobileMenuButtonLinkStyles, mobileMenuButtonStyles } from '../styles/mobile-menu'

const scrollContainerWithoutBar = css`
  overflow-y: scroll;
  -ms-overflow-style: none; /* for Internet Explorer, Edge */
  scrollbar-width: none; /* for Firefox */

  &::-webkit-scrollbar {
    display: none; /* for Chrome, Safari, and Opera */
  }
`

export const LogoLink = styled(Link)`
  position: absolute;
  left: 50%;
  transform: translateX(-50%);
  margin: 18px auto 0;
  display: block;

  @media (min-width: 576px) {
    margin-top: 16px;
  }

  @media (min-width: 768px) {
    margin-top: 22px;
  }
`

export const DfhLogoImage = styled.img`
  display: block;
  height: 25px;

  @media (min-width: 576px) {
    height: 29px;
  }

  @media (min-width: 768px) {
    height: 35px;
  }

  @media print {
    display: none;
  }
`

export const DispensaryLogoImage = styled.img`
  display: block;
  height: 44px;
  margin-top: -10px;

  @media (min-width: 576px) {
    margin-top: -8px;
  }

  @media (min-width: 768px) {
    height: 56px;
    margin-top: -10px;
  }

  @media print {
    display: none;
  }
`

export const NavOverlight = styled.div`
  position: fixed;
  visibility: hidden;
  z-index: 5;
  top: 0;
  width: 100vw;
  height: 100vh;
  left: 0;
  background-color: rgba(0, 0, 0, 0.8);
`

export const NavContainer = styled.div`
  display: flex;
  flex-direction: column;
  padding-top: 17px;
  position: fixed;
  top: 0;
  width: 70vw;
  min-width: 320px;
  height: 100vh;
  min-height: 100%;
  z-index: 10;
  transform: translate(-100%, 0px);
  background-color: ${({ theme }) => theme.colors.component.backgroundDarkBlue};
  color: ${({ theme }) => theme.colors.grayscale.white};
  overflow-x: hidden;
  ${scrollContainerWithoutBar};

  @media (min-width: 768px) {
    padding-top: 24px;
  }

  @media print {
    background-color: ${({ theme }) => theme.colors.grayscale.white};
  }
`

export const CloseBox = styled.div`
  display: flex;
  flex: 0;
  justify-content: flex-start;
  padding: 0.8rem var(--mobile-menu-padding-x);
  position: relative;

  @media (min-width: 768px) {
    padding-top: 1rem;
    padding-bottom: 1rem;
  }
`

export const NavMenu = styled(MenuAccordion)`
  font-family: ${({ theme }) => theme.fontFamilies.robotoCondensed};
  padding-bottom: 5rem;
  background-color: ${({ theme }) => theme.colors.component.backgroundDarkBlue};
  flex: 1;
  ${scrollContainerWithoutBar};
`

export const MobileMenuButton = styled.button`
  ${mobileMenuButtonStyles};
  position: absolute;
  left: var(--mobile-header-button-x);
  top: var(--mobile-header-button-y);
  display: block;
  cursor: pointer;
`

export const MobileMenuIcon = styled.img`
  display: block;
  width: 35px;
  height: 35px;

  @media (min-width: 768px) {
    width: 40px;
    height: 40px;
  }

  @media print {
    display: none;
  }
`

export const MobileCartButton = styled.button`
  ${mobileMenuButtonStyles};
  position: absolute;
  right: var(--mobile-header-button-x);
  top: var(--mobile-header-button-y);
  display: block;
  visibility: visible;
  cursor: pointer;
`

export const MobileSearchInput = styled.div`
  display: flex;
  justify-content: center;
  position: absolute;
  left: 50%;
  transform: translateX(-50%);
  bottom: 16px;
  width: 100%;
`

export const MobileCartIcon = styled(MobileCartIconImport)`
  color: ${({ theme }) => theme.colors.brand.red};
  font-family: ${({ theme }) => theme.fontFamilies.robotoCondensed};
  width: 27px;
  height: 27px;
  .cart-icon-qty-text {
    transition: opacity 0.35s;
    opacity: ${({ quantityText }) => (quantityText ? 1 : 0)};
  }

  @media (min-width: 768px) {
    width: 31px;
    height: 31px;
  }

  @media print {
    display: none;
  }
`

export const MobileSearchButton = styled.button`
  ${mobileMenuButtonLinkStyles};
  flex: 1;
  color: ${({ theme }) => theme.colors.brand.red};

  @media (min-width: 576px) {
    padding-top: 0.3rem;
    padding-bottom: 0.8rem;
  }

  @media (min-width: 768px) {
    padding-top: 0.6rem;
    padding-bottom: 1rem;
  }
`

export const CloseButton = styled.button`
  ${mobileMenuButtonStyles};
  display: block;
  margin-bottom: auto;
`

export const CloseIcon = styled.img`
  display: block;
  width: 40px;
  height: 40px;

  @media (min-width: 768px) {
    width: 46px;
    height: 46px;
  }
`

export const MobileLoginLink = styled(LoginLink)`
  ${mobileMenuButtonLinkStyles};
`

export const MobileRegistrationLink = styled(RegistrationLink)`
  ${mobileMenuButtonLinkStyles};
`

export const MobileLogoutLink = styled(LogoutLink)`
  ${mobileMenuButtonLinkStyles};
`

export const TopLevelAccordionCollapse = styled(MenuAccordionCollapse)`
  margin-top: 0.8em;
`
